import React from 'react';

const featproductCircle = (props) => {
  return (
    <svg className={props.styled || ''} viewBox="0 0 374 374" fill="none">
      <circle cx="186" cy="186" r="186" stroke="black" />
    </svg>
  );
};

export default featproductCircle;
